module.exports = {
  EDIT: 'Чтение и редактирование',
  PRIVATE: 'Только владельцу',
  VIEW: 'Только на чтение',
  VIEWGROUP: 'Только на чтение для группы',
  EDITGROUP: 'Чтение и редактирование для группы',
};
